import client from '../http_client';
import { JuaForecastResponse } from './types';

const root = '/v1/forecasting';

export class ForecastService {
  public static async getLatestAtPoint(
    model: string,
    latitude: number,
    longitude: number,
    minLeadTime: number,
    maxLeadTime: number,
    full?: boolean,
    ensembleStats?: string[],
    demo?: boolean,
  ): Promise<JuaForecastResponse> {
    let params = `min_lead_time=${minLeadTime}&max_lead_time=${maxLeadTime}&use_new_naming=true`;

    if (full) {
      params += `&full=true`;
    }

    if (ensembleStats && ensembleStats.length > 0) {
      for (const stat of ensembleStats) {
        params += `&ensemble_stats=${encodeURIComponent(stat)}`;
      }
    }

    const endpoint = demo ? `${root}/demo` : root;
    const url = `${endpoint}/${model}/forecasts/latest/${latitude},${longitude}?${params}`;
    const response = await client.get<JuaForecastResponse>(url);
    return response.data;
  }

  public static async getInitTimeAtPoint(
    model: string,
    initTime: string,
    latitude: number,
    longitude: number,
    minLeadTime: number,
    maxLeadTime: number,
    ensembleStats?: string[],
    demo?: boolean,
  ): Promise<JuaForecastResponse> {
    let params = `min_lead_time=${minLeadTime}&max_lead_time=${maxLeadTime}`;
    if (ensembleStats && ensembleStats.length > 0) {
      for (const stat of ensembleStats) {
        params += `&ensemble_stats=${encodeURIComponent(stat)}`;
      }
    }

    const endpoint = demo ? `${root}/demo` : root;
    const url = `${endpoint}/${model}/forecasts/${initTime}/${latitude},${longitude}?${params}&use_new_naming=true`;
    const response = await client.get<JuaForecastResponse>(url);
    return response.data;
  }

  public static async getAvailableInitTimes(model: string, demo?: boolean): Promise<string[]> {
    const endpoint = demo ? `${root}/demo` : root;
    const url = `${endpoint}/${model}/forecasts/available_init_times`;
    const response = await client.get<{ init_times: string[] }>(url);
    return response.data.init_times;
  }

  public static async getAvailableInitTimesWithOverlap(
    model: string,
    startDate: string,
    endDate: string,
    minOverlapDays: number = 2.0,
    demo?: boolean,
  ): Promise<string[]> {
    const params = new URLSearchParams({
      start_date: startDate,
      end_date: endDate,
      min_overlap_days: minOverlapDays.toString(),
    });
    const endpoint = demo ? `${root}/demo/` : root;
    const url = `${endpoint}/${model}/forecasts/available_init_times_with_overlap?${params}`;
    const response = await client.get<{ init_times: string[] }>(url);
    return response.data.init_times;
  }
}
